<template>
    <div class="desktop-preview-wrapper" :class="{active: clientWidth>815}" :style="style">
        <SiteSearchFrame  v-if="clientWidth>815" :config="config" :width="width" :height="height" :demo="demo" :is-visible="isVisible" :padding-top="htmlPaddingTop" :content-img="contentImg" :header-img="headerImg"/>
        <span v-else>{{texts.preview.desktopUnavailable}}</span>
    </div>
</template>

<script>
import SiteSearchFrame from "./SiteSearchFrame";
export default {
  name: "DesktopPreview",
  components: { SiteSearchFrame },
  props: {
    config: {
      type: Object,
      required: true
    },
    demo: String,
    isVisible: Boolean
  },
  data() {
    return {
      width: 1920,
      height: 1080,
      clientWidth: document.documentElement.clientWidth || window.innerWidth,
      style: {
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% auto"
      },
      htmlPaddingTop: 0,
      timeoutId: -1
    };
  },
  computed: {
    contentImg() {
      return "https://cdn2.hubspot.net/hubfs/3826488/Website/Visual%20Configurator/desktop_browser_content.93754f9.svg";//require("../../assets/desktop_browser_content.svg");
    },
    headerImg() {
      return require("../../assets/desktop_browser_ui.png");
    }
  },
  methods: {
    computeSize() {
      const isInlinePreview = window.matchMedia ? window.matchMedia("(min-width: 1700px)").matches : (document.documentElement.clientWidth||window.innerWidth) >= 1700
      this.clientWidth = document.documentElement.clientWidth || window.innerWidth;
      this.width = 1920;
      this.height = 1080;
      const relativePadding = 57 / 2034;
      const wrapperWidth =
        !isInlinePreview
          ? this.clientWidth
          : Math.min(1668, this.clientWidth);

      const containerWidth = Math.max(
        1052,
        wrapperWidth * (isInlinePreview ? 0.65 : 1) + (isInlinePreview ? 0 : -32)
      );
   
      const absolutePadding = Math.floor(containerWidth * relativePadding);
      const previewWidth =
        Math.min(containerWidth, this.width) - 2 * absolutePadding;
      const zoom = previewWidth / this.width;
      this.width = Math.floor(previewWidth);
      this.height = Math.floor(this.height * zoom);
      this.style.paddingTop = absolutePadding + "px";
      this.style.paddingLeft = absolutePadding + "px";
      this.style.paddingBottom = 468 / 2034 * containerWidth + "px";
      this.htmlPaddingTop = Math.ceil(67 * zoom);
    }
  },
  mounted() {
    this.computeSize();
    window.addEventListener("resize", function(){
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(this.computeSize.bind(this), 200);
    }.bind(this));
  }
};
</script>

<style>
.desktop-preview-wrapper {
	box-sizing: content-box;
}

.desktop-preview-wrapper.active {
  background: url("https://cdn2.hubspot.net/hubfs/3826488/Website/Visual%20Configurator/desktop_background.430fbe7.png");
}

.desktop-preview-wrapper.active iframe {
  background: url("../../assets/desktop_browser_ui.png");
  /* background: url('../../assets/desktop_browser_ui.svg'); */
  background-repeat: no-repeat;
  background-position: 0 0;
  background-size: 100% auto;
}
</style>


// WEBPACK FOOTER //
// src/components/preview/DesktopPreview.vue